import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { Grey3, red } from '../../../color_utils';
import PropTypes from 'prop-types';

const InformationAlert = ({
    title,
    message,
    severity,
    onClose, // this is used when wrapping this component in a MUI Collapse animate in/out - prop is not required
}) => (
    <Alert
        severity={severity}
        variant="outlined"
        sx={{
            color: severity === "error" ? red : Grey3,
            '&.MuiAlert-outlinedInfo': {
                border: `1px solid ${Grey3}`
            },
            '&.MuiAlert-root': { lineHeight: '17px', fontSize: '13px' },
            '& .MuiAlert-icon': { color: severity === "error" ? red : Grey3 }
        }}
        onClose={onClose}
    >
        <AlertTitle
            sx={{ color: severity === "error" ? red : Grey3, fontWeight: 700, marginBottom: 0 }}
        >
            {title}
        </AlertTitle>
        {message}
    </Alert>
);

InformationAlert.propTypes = {
    message: PropTypes.number.isRequired,
    severity: PropTypes.string,
    title: PropTypes.string,
    onClose: PropTypes.func
};

InformationAlert.defaultProps = {
    title: "Information",
    severity: "info",
    onClose: () => {}
};

export default InformationAlert;
